/* Neriela theme · storefront behavior
   Cart drawer (AJAX + Section Rendering API), product form, variant picker,
   gallery, delivery estimate, holiday countdown, sticky add to bag,
   collection filters, article table of contents, mobile menu. No dependencies. */
(function () {
  'use strict';

  var N = window.Neriela || {};
  var routes = N.routes || {};
  var strings = N.strings || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, event) {
    var nodes = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || N.currency || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Overlay panels (menu + cart) ---------- */
  function Panel(root, panelSel) {
    this.root = root;
    this.panel = $(panelSel, root);
    this.lastFocus = null;
    var self = this;
    root.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') { self.close(); }
      if (e.key === 'Tab') { trapFocus(self.panel, e); }
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-panel-close]')) { e.preventDefault(); self.close(); }
    });
  }
  Panel.prototype.open = function (opener) {
    this.lastFocus = opener || document.activeElement;
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-overlay');
    var panel = this.panel;
    window.setTimeout(function () { panel.focus(); }, 60);
  };
  Panel.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-overlay');
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var root = $('[data-menu-drawer]');
    if (!root) return;
    var menu = new Panel(root, '.menu-drawer__panel');
    $$('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.setAttribute('aria-expanded', 'true');
        menu.open(btn);
      });
    });
    var originalClose = menu.close.bind(menu);
    menu.close = function () {
      $$('[data-menu-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
      originalClose();
    };
  }

  /* ---------- Cart ---------- */
  var Cart = {
    root: null,
    panel: null,

    init: function () {
      this.root = $('[data-cart-drawer]');
      if (!this.root) return;
      this.panel = new Panel(this.root, '.drawer__panel');
      var self = this;

      $$('[data-cart-open]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          self.open(link);
        });
      });

      this.root.addEventListener('click', function (e) {
        var qtyBtn = e.target.closest('[data-qty-change]');
        if (qtyBtn) {
          e.preventDefault();
          var line = qtyBtn.closest('[data-line-key]');
          var input = $('input', line);
          var next = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
          self.change(line.getAttribute('data-line-key'), next);
          return;
        }
        var remove = e.target.closest('[data-line-remove]');
        if (remove) {
          e.preventDefault();
          self.change(remove.closest('[data-line-key]').getAttribute('data-line-key'), 0);
          return;
        }
        var addBtn = e.target.closest('[data-add-variant]');
        if (addBtn) {
          e.preventDefault();
          addBtn.classList.add('is-loading');
          self.add([{ id: parseInt(addBtn.getAttribute('data-add-variant'), 10), quantity: 1 }], addBtn.getAttribute('data-title'));
        }
      });

      this.root.addEventListener('change', function (e) {
        var qtyInput = e.target.closest('[data-line-key] input');
        if (qtyInput) {
          self.change(qtyInput.closest('[data-line-key]').getAttribute('data-line-key'), Math.max(0, parseInt(qtyInput.value, 10) || 0));
          return;
        }
        var gift = e.target.closest('[data-cart-gift]');
        if (gift) {
          if (gift.checked && N.giftBoxVariantId) {
            self.add([{ id: N.giftBoxVariantId, quantity: 1 }], null, { keepNote: true });
          } else if (!gift.checked) {
            var key = gift.getAttribute('data-gift-key');
            if (key) self.change(key, 0);
          }
        }
      });
    },

    hasGift: function () {
      var inner = this.root && $('[data-cart-inner]', this.root);
      return !!(inner && inner.getAttribute('data-has-gift') === 'true');
    },

    open: function (opener) {
      if (!this.root) { window.location.href = routes.cart; return; }
      this.panel.open(opener);
    },

    busy: function (on) {
      if (this.root) this.root.classList.toggle('is-busy', on);
    },

    render: function (html, addedTitle) {
      if (!html || !this.root) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-inner]', doc);
      var current = $('[data-cart-inner]', this.root);
      if (!fresh || !current) return;
      current.replaceWith(fresh);
      var count = fresh.getAttribute('data-item-count') || '0';
      $$('[data-cart-bubble]').forEach(function (b) {
        b.textContent = count;
        b.hidden = count === '0';
      });
      $$('[data-cart-open]').forEach(function (b) {
        var label = b.getAttribute('data-label-template');
        if (label) b.setAttribute('aria-label', label.replace('{{ count }}', count));
      });
      if (addedTitle) {
        var note = $('[data-added-note]', fresh);
        if (note) {
          $('[data-added-title]', note).textContent = addedTitle;
          note.hidden = false;
        }
      }
      initDelivery(fresh);
    },

    request: function (url, body) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || json.status) { throw new Error(json.description || json.message || strings.error); }
          return json;
        });
      });
    },

    add: function (items, addedTitle) {
      var self = this;
      if (N.cartType !== 'drawer' || !this.root) {
        return this.request(routes.cartAdd, { items: items }).then(function () { window.location.href = routes.cart; });
      }
      this.busy(true);
      return this.request(routes.cartAdd, { items: items }).then(function (json) {
        var title = addedTitle;
        if (!title && json.items && json.items[0]) title = json.items[0].product_title;
        self.render(json.sections && json.sections['cart-drawer'], title);
        self.busy(false);
        self.open();
        return json;
      }).catch(function (err) {
        self.busy(false);
        throw err;
      });
    },

    change: function (key, quantity) {
      var self = this;
      this.busy(true);
      return this.request(routes.cartChange, { id: key, quantity: quantity }).then(function (json) {
        self.render(json.sections && json.sections['cart-drawer']);
        self.busy(false);
      }).catch(function (err) {
        self.busy(false);
        var slot = $('[data-cart-error]', self.root);
        if (slot) { slot.textContent = err.message; slot.hidden = false; }
      });
    }
  };

  /* ---------- Product page ---------- */
  function initProductSections() {
    $$('[data-product-section]').forEach(function (section) {
      var jsonEl = $('[data-product-json]', section);
      var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
      var form = $('form[data-product-form]', section);

      // Gallery
      $$('[data-thumb]', section).forEach(function (thumb) {
        thumb.addEventListener('click', function () { showMedia(section, thumb.getAttribute('data-thumb')); });
      });

      // Variant picker
      var picker = $('[data-variant-picker]', section);
      if (picker && product) {
        picker.addEventListener('change', function () {
          var selected = $$('fieldset', picker).map(function (fs) {
            var checked = $('input:checked', fs);
            return checked ? checked.value : null;
          });
          var variant = product.variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === selected[i]; });
          });
          $$('fieldset', picker).forEach(function (fs, i) {
            var label = $('[data-option-selected]', fs);
            if (label) label.textContent = selected[i] || '';
          });
          updateVariant(section, variant);
        });
      }

      // Add to bag
      if (form) {
        form.addEventListener('submit', function (e) {
          if (N.cartType !== 'drawer') return;
          e.preventDefault();
          var submit = $('[type="submit"]', form);
          var error = $('[data-form-error]', section);
          if (error) error.hidden = true;
          var data = new FormData(form);
          var main = { id: parseInt(data.get('id'), 10), quantity: parseInt(data.get('quantity') || '1', 10) };
          var props = {};
          data.forEach(function (value, key) {
            if (value && key.indexOf('properties[') === 0 && key.charAt(key.length - 1) === ']') props[key.slice(11, -1)] = value;
          });
          if (Object.keys(props).length) main.properties = props;
          var items = [main];
          $$('[data-bundle-checkbox]', section).forEach(function (box) {
            if (box.checked) items.push({ id: parseInt(box.value, 10), quantity: 1 });
          });
          var gift = $('[data-gift-checkbox]', section);
          if (gift && gift.checked && !Cart.hasGift()) items.push({ id: parseInt(gift.value, 10), quantity: 1 });
          if (submit) submit.classList.add('is-loading');
          $$('[data-sticky-submit]').forEach(function (b) { b.classList.add('is-loading'); });
          Cart.add(items, form.getAttribute('data-product-title')).catch(function (err) {
            if (error) { error.textContent = err.message || strings.addError; error.hidden = false; }
          }).then(function () {
            if (submit) submit.classList.remove('is-loading');
            $$('[data-sticky-submit]').forEach(function (b) { b.classList.remove('is-loading'); });
          });
        });
      }

      // Sticky add to bag
      var sticky = $('[data-sticky-atc]');
      var mainButton = form && $('[type="submit"]', form);
      if (sticky && mainButton && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var below = entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !entry.isIntersecting && below);
          });
        });
        io.observe(mainButton);
        $$('[data-sticky-submit]', sticky).forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (form.requestSubmit) form.requestSubmit(); else mainButton.click();
          });
        });
      }

      // Live total on the add button
      var totalTarget = $('[data-atc-total]', section);
      if (totalTarget) {
        var recompute = function () {
          var base = parseInt(totalTarget.getAttribute('data-base'), 10) || 0;
          var sum = base;
          var pieces = [base];
          $$('[data-bundle-checkbox]', section).forEach(function (b) {
            if (!b.checked) return;
            var p = parseInt(b.getAttribute('data-price'), 10) || 0;
            sum += p;
            pieces.push(p);
          });
          // Mirrors the automatic discount: 10% off the cheaper piece when two pieces or more.
          if (pieces.length > 1) sum -= Math.round(Math.min.apply(null, pieces) * 0.1);
          var g = $('[data-gift-checkbox]', section);
          if (g && g.checked) sum += parseInt(g.getAttribute('data-price'), 10) || 0;
          totalTarget.textContent = formatMoney(sum);
          $$('[data-sticky-total]').forEach(function (el) { el.textContent = formatMoney(sum); });
        };
        section.addEventListener('change', function (e) {
          if (e.target.closest('[data-bundle-checkbox], [data-gift-checkbox]')) recompute();
        });
        section.addEventListener('neriela:variant', recompute);
      }
    });
  }

  function showMedia(section, mediaId) {
    var slides = $$('[data-media-id]', section);
    var found = slides.some(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
    if (!found) return;
    slides.forEach(function (slide) { slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === String(mediaId)); });
    $$('[data-thumb]', section).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(mediaId) ? 'true' : 'false'); });
  }

  function updateVariant(section, variant) {
    var buttons = $$('[data-add-button]', section).concat($$('[data-sticky-submit]'));
    if (!variant) {
      buttons.forEach(function (b) { b.disabled = true; var t = $('[data-add-label]', b); if (t) t.textContent = strings.unavailable; });
      return;
    }
    $$('input[name="id"]', section).forEach(function (input) { input.value = variant.id; });
    $$('[data-variant-price]', section).forEach(function (el) {
      el.innerHTML = (variant.compare_at_price > variant.price ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s> ' : '') + '<span class="price__current">' + formatMoney(variant.price) + '</span>';
    });
    $$('[data-installment]', section).forEach(function (el) { el.textContent = formatMoney(Math.round(variant.price / 4)); });
    var total = $('[data-atc-total]', section);
    if (total) total.setAttribute('data-base', variant.price);
    buttons.forEach(function (b) {
      b.disabled = !variant.available;
      var t = $('[data-add-label]', b);
      if (t) t.textContent = variant.available ? strings.addToBag : strings.soldOut;
    });
    if (variant.featured_media) showMedia(section, variant.featured_media.id);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
    section.dispatchEvent(new CustomEvent('neriela:variant', { detail: variant }));
  }

  /* ---------- Delivery estimate ---------- */
  function parseDate(str) {
    if (!str) return null;
    var p = str.split('-').map(function (n) { return parseInt(n, 10); });
    if (p.length !== 3 || p.some(isNaN)) return null;
    return new Date(p[0], p[1] - 1, p[2], 23, 59, 59);
  }
  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function shortDate(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }

  function initDelivery(root) {
    $$('[data-delivery]', root).forEach(function (el) {
      var now = new Date();
      var hMin = parseInt(el.getAttribute('data-handling-min'), 10) || 0;
      var hMax = parseInt(el.getAttribute('data-handling-max'), 10) || 0;
      var tMin = parseInt(el.getAttribute('data-transit-min'), 10) || 0;
      var tMax = parseInt(el.getAttribute('data-transit-max'), 10) || 0;
      var min = addBusinessDays(now, hMin + tMin);
      var max = addBusinessDays(now, hMax + tMax);
      var range = $('[data-delivery-range]', el);
      if (range) range.textContent = shortDate(min) + ' – ' + shortDate(max);
      var holidayEl = $('[data-delivery-holiday]', el);
      var holiday = parseDate(el.getAttribute('data-holiday-date'));
      var cutoff = parseDate(el.getAttribute('data-holiday-cutoff'));
      if (holidayEl && holiday && cutoff) {
        if (now <= cutoff) {
          holidayEl.textContent = max < holiday ? el.getAttribute('data-before-label') : el.getAttribute('data-order-by-label');
          holidayEl.hidden = false;
        } else {
          holidayEl.hidden = true;
        }
      }
      $$('[data-holiday-inline]', el.parentNode || el).forEach(function (inline) {
        inline.hidden = !(holiday && cutoff && now <= cutoff && max < holiday);
      });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var date = parseDate(el.getAttribute('data-countdown'));
      if (!date) return;
      var start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      var days = Math.ceil((start - new Date()) / 86400000);
      var n = $('[data-countdown-n]', el);
      if (days <= 0) { var wrap = el.closest('[data-countdown-wrap]'); if (wrap) wrap.hidden = true; return; }
      if (n) n.textContent = String(days);
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    var root = $('[data-collection-root]');
    if (!root) return;
    var form = $('[data-filter-form]', root);
    var sectionId = root.getAttribute('data-section-id');

    function load(url) {
      var area = $('[data-products-area]', root);
      if (area) area.classList.add('is-loading');
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(fetchUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-collection-root]', doc);
        if (fresh) {
          root.replaceWith(fresh);
          window.history.replaceState({}, '', url);
          initFilters();
        } else {
          window.location.href = url;
        }
      }).catch(function () { window.location.href = url; });
    }

    function urlFromForm() {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      var qs = params.toString();
      return window.location.pathname + (qs ? '?' + qs : '');
    }

    if (form) {
      form.addEventListener('change', function () { load(urlFromForm()); });
      form.addEventListener('submit', function (e) { e.preventDefault(); load(urlFromForm()); });
    }
    $$('[data-filter-link]', root).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); load(a.getAttribute('href')); });
    });
  }

  /* ---------- Article table of contents ---------- */
  function slugify(str) {
    return str.toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }
  function initToc() {
    $$('[data-article-body]').forEach(function (body) {
      var toc = $('[data-auto-toc]');
      var list = toc && $('[data-toc-list]', toc);
      var headings = $$('h2', body);
      var starSvg = '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.5L20.5 17H3.5z M12 21.5L3.5 7h17z"></path></svg>';
      headings.forEach(function (h) {
        if (!h.id) h.id = slugify(h.textContent);
        if (!$('.chip-icon', h)) {
          var chip = document.createElement('span');
          chip.className = 'chip-icon';
          chip.setAttribute('aria-hidden', 'true');
          chip.innerHTML = starSvg.replace('width="16" height="16"', 'width="20" height="20"');
          h.insertBefore(chip, h.firstChild);
        }
        if (list) {
          var li = document.createElement('a');
          li.href = '#' + h.id;
          li.innerHTML = starSvg;
          li.appendChild(document.createTextNode(h.textContent.trim()));
          list.appendChild(li);
        }
      });
      if (toc) toc.hidden = headings.length < 2;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    Cart.init();
    initProductSections();
    initDelivery(document);
    initCountdowns();
    initFilters();
    initToc();
  });

  document.addEventListener('shopify:section:load', function () {
    initDelivery(document);
    initCountdowns();
  });

  window.NerielaCart = Cart;
})();
